"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAssignedLoanTapeArtifacts = exports.materializeChangeset = exports.materializeChangesetForMasterLoanTapeType = exports.materializeChangesetForPreassignedArchetypes = exports.materializeAssignedLoanTapeChangeset = exports.createAssignedLoanTapeArtifact = exports.getAssociatedReceivableResponseTapes = void 0;
const lodash_1 = __importDefault(require("lodash"));
const remeda_1 = require("remeda");
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const mesh = __importStar(require("./mesh"));
const preview = __importStar(require("./receivableResponseTapePreview"));
const { cloneDeep, remove } = lodash_1.default;
const getAssociatedReceivableResponseTapes = ({ receivableResponseTapes, dataTapeDependencies, masterLoanTapeId, }) => {
    const filterAdapter = (rrtIds) => (0, remeda_1.filter)(receivableResponseTapes, (rrt) => rrtIds.includes(rrt.id));
    return (0, remeda_1.pipe)(dataTapeDependencies, (0, remeda_1.filter)((dep) => dep.inputArtifactId === masterLoanTapeId), (0, remeda_1.map)((dep) => dep.outputArtifactId), filterAdapter);
};
exports.getAssociatedReceivableResponseTapes = getAssociatedReceivableResponseTapes;
const createAssignedLoanTapeArtifact = ({ masterLoanTape, creditFacilitySlug, }) => {
    (0, common_1.finleyAssert)(masterLoanTape.loanProductSlug, 'loanProductSlug must exist for masterLoanTape');
    return {
        id: (0, uuid_1.v4)(),
        type: 'assignedLoanTape',
        configuration: {},
        loanProductSlug: masterLoanTape.loanProductSlug,
        creditFacilitySlug,
        artifactDocumentId: masterLoanTape.artifactDocumentId,
        externalFilename: null,
        artifactSlug: `assignedLoanTape_${masterLoanTape.loanProductSlug}_${creditFacilitySlug}`, // unique for assignedLoanTape
    };
};
exports.createAssignedLoanTapeArtifact = createAssignedLoanTapeArtifact;
const materializeAssignedLoanTapeChangeset = ({ masterLoanTape, receivableResponseTape, dataTapeDependencies, }) => {
    const { creditFacilitySlug, artifactSlug } = receivableResponseTape;
    (0, common_1.finleyAssert)(creditFacilitySlug, `creditFacilitySlug must defined for receivable response tape ${artifactSlug}`);
    const assignedLoanTape = (0, exports.createAssignedLoanTapeArtifact)({
        masterLoanTape,
        creditFacilitySlug,
    });
    const dataTapeDependency = utils.getDependency({
        outputArtifactId: receivableResponseTape.id,
        inputArtifactId: masterLoanTape.id,
        dataTapeDependencies,
    });
    const { outputDependency, inputDependency } = utils.insertDependency({
        dataTapeDependency,
        insertId: assignedLoanTape.id,
    });
    return {
        assignedLoanTape,
        outputDependency,
        inputDependency,
        dependencyForRemoval: dataTapeDependency,
    };
};
exports.materializeAssignedLoanTapeChangeset = materializeAssignedLoanTapeChangeset;
// for preassigned and preassignedMaster
const materializeChangesetForPreassignedArchetypes = ({ dataTapeDependencies, dataTapes, loanProductSlugs, }) => {
    const dataTapesForInsert = [];
    const dependenciesForInsert = [];
    const dependenciesForRemoval = [];
    const masterLoanTapes = utils
        .filterMasterLoanTapes({ dataTapes })
        .filter((dataTape) => lodash_1.default.includes(loanProductSlugs, dataTape.loanProductSlug));
    const receivableResponseTapes = utils.filterReceivableResponseTapes({
        dataTapes,
    });
    (0, remeda_1.forEach)(masterLoanTapes, (masterLoanTape) => {
        const associatedReceivableResponseTapes = (0, exports.getAssociatedReceivableResponseTapes)({
            receivableResponseTapes,
            dataTapeDependencies,
            masterLoanTapeId: masterLoanTape.id,
        });
        (0, remeda_1.forEach)(associatedReceivableResponseTapes, (receivableResponseTape) => {
            const { assignedLoanTape, outputDependency, inputDependency, dependencyForRemoval, } = (0, exports.materializeAssignedLoanTapeChangeset)({
                masterLoanTape,
                receivableResponseTape,
                dataTapeDependencies,
            });
            dataTapesForInsert.push(assignedLoanTape);
            dependenciesForInsert.push(outputDependency);
            dependenciesForInsert.push(inputDependency);
            dependenciesForRemoval.push(dependencyForRemoval);
        });
    });
    return {
        dependenciesForInsert,
        dataTapesForInsert,
        dependenciesForRemoval,
    };
};
exports.materializeChangesetForPreassignedArchetypes = materializeChangesetForPreassignedArchetypes;
const materializeChangesetForMasterLoanTapeType = ({ dataTapeDependencies, dataTapes, loanProductSlugs, }) => {
    const dataTapesForInsert = [];
    const dependenciesForInsert = [];
    const dependenciesForRemoval = [];
    const masterLoanTapes = utils
        .filterMasterLoanTapes({ dataTapes })
        .filter((dataTape) => lodash_1.default.includes(loanProductSlugs, dataTape.loanProductSlug));
    const receivableResponseTapes = utils.filterReceivableResponseTapes({
        dataTapes,
    });
    // creates assignedLoanTape artifacts, and assignedLoanTape<>receivableResponseTape deps
    // and the masterLoanTape<>receivableResponseTape edges to remove
    (0, remeda_1.forEach)(masterLoanTapes, (masterLoanTape) => {
        const associatedReceivableResponseTapes = (0, exports.getAssociatedReceivableResponseTapes)({
            receivableResponseTapes,
            dataTapeDependencies,
            masterLoanTapeId: masterLoanTape.id,
        });
        (0, remeda_1.forEach)(associatedReceivableResponseTapes, (receivableResponseTape) => {
            const { assignedLoanTape, outputDependency, dependencyForRemoval, } = (0, exports.materializeAssignedLoanTapeChangeset)({
                masterLoanTape,
                receivableResponseTape,
                dataTapeDependencies,
            });
            // Note: unlike preassignedMasterLoanTape and preassignedLoanTape, we don't
            // push the inputDependency node, which represents a masterLoanTape<>assignedLoanTape edge
            // this should NOT exist in the masterLoanTape BBPL flow
            dataTapesForInsert.push(assignedLoanTape);
            dependenciesForInsert.push(outputDependency);
            dependenciesForRemoval.push(dependencyForRemoval);
        });
    });
    const { receivableResponseTapePreview, receivableResponseTapePreviewDependencies, } = preview.materializeReceivableResponseTapePreviewChangeset({
        loanProductSlugs,
        masterLoanTapes,
    });
    dataTapesForInsert.push(receivableResponseTapePreview);
    (0, remeda_1.forEach)(receivableResponseTapePreviewDependencies, (dep) => dependenciesForInsert.push(dep));
    return {
        dependenciesForInsert,
        dataTapesForInsert,
        dependenciesForRemoval,
    };
};
exports.materializeChangesetForMasterLoanTapeType = materializeChangesetForMasterLoanTapeType;
const materializeChangeset = ({ dataTapeDependencies, dataTapes, loanTapeType, loanProductSlugs, }) => {
    switch (loanTapeType) {
        case 'masterLoanTape':
            return (0, exports.materializeChangesetForMasterLoanTapeType)({
                dataTapeDependencies,
                dataTapes,
                loanProductSlugs,
            });
        case 'preassignedLoanTape':
        case 'preassignedMasterLoanTape':
            return (0, exports.materializeChangesetForPreassignedArchetypes)({
                dataTapeDependencies,
                dataTapes,
                loanProductSlugs,
            });
        default:
            return (0, common_1.finleyAssertUnreachable)(loanTapeType);
    }
};
exports.materializeChangeset = materializeChangeset;
/**
 * Adds assigned loan tape artifacts + dependencies.
 *
 * NOTE: ReceivableResponseTapePreviews are also added for masterLoanTapeType
 * when breaking the DAG between masterLoanTape<>receivableResponseTapePreview and
 * assignedLoanTape<>receivableResponseTape
 */
const addAssignedLoanTapeArtifacts = ({ dbGraph, loanTapeTypeMap, }) => {
    const dataTapeDependencies = cloneDeep(dbGraph.dataTapeDependencies);
    const dataTapes = cloneDeep(dbGraph.dataTapes);
    const lpCfSlugGroupingsWithType = mesh.getLpCfSlugGroupingsWithTypeFromMasterLoanTapes({
        dbGraph: {
            dataTapes,
            dataTapeDependencies,
        },
        loanTapeTypeMap,
    });
    (0, remeda_1.forEach)(lpCfSlugGroupingsWithType, (grouping) => {
        const { loanTapeType, loanProductSlugs } = grouping;
        // master loan tape archetype (master and preassignedMaster) should only have
        // 1 instance of master loan tape artifact per loan product.  However, preassignedLoanTape
        // types can have multiple master loan tape artifact per loan product.  While this assertion is not needed for attach,
        // it is a required property to be able to properly detach synthetic nodes
        if (loanTapeType !== 'preassignedLoanTape') {
            const masterLoanTapes = utils.filterMasterLoanTapes({ dataTapes });
            const masterLoanTapeSlugs = masterLoanTapes.map(({ artifactSlug }) => artifactSlug);
            const uniqLoanProductSlugs = (0, remeda_1.pipe)(masterLoanTapes, (0, remeda_1.map)(({ loanProductSlug }) => loanProductSlug), (0, remeda_1.uniq)());
            (0, common_1.finleyAssert)(uniqLoanProductSlugs.length === masterLoanTapes.length, `Only 1 master loan tape per loanProductSlug is allowed for MasterLoanTape and PreassignedMasterLoanTape types: uniqLoanProductSlugs: ${uniqLoanProductSlugs.join(', ')}, masterLoanTapes: ${masterLoanTapeSlugs.join(', ')}`);
        }
        const { dependenciesForInsert, dataTapesForInsert, dependenciesForRemoval, } = (0, exports.materializeChangeset)({
            dataTapeDependencies,
            dataTapes,
            loanTapeType,
            loanProductSlugs,
        });
        (0, remeda_1.forEach)(dependenciesForInsert, (dep) => {
            dataTapeDependencies.push(dep);
        });
        (0, remeda_1.forEach)(dataTapesForInsert, (tape) => {
            dataTapes.push(tape);
        });
        (0, remeda_1.forEach)(dependenciesForRemoval, (dep) => {
            // remove mutates original array
            const removedDependency = remove(dataTapeDependencies, (dependency) => dependency.inputArtifactId === dep.inputArtifactId &&
                dependency.outputArtifactId === dep.outputArtifactId);
            (0, common_1.finleyAssert)(removedDependency.length === 1, 'unable to remove dependency');
        });
    });
    utils.ensureNoDuplicateDependencies({
        functionName: 'addAssignedLoanTapeArtifacts',
        dbGraph: {
            dataTapes,
            dataTapeDependencies,
        },
    });
    return { dataTapeDependencies, dataTapes };
};
exports.addAssignedLoanTapeArtifacts = addAssignedLoanTapeArtifacts;
//# sourceMappingURL=assignedLoanTape.js.map